'use es6';

import * as ActionTypes from 'MeetingsAdmin/redux/actions/ActionTypes';
import { handleActions, combineActions } from 'flux-actions';
const initialState = [];
export default handleActions({
  [combineActions(ActionTypes.FETCH_MEETINGS_USERS_SUCCEEDED)](_, action) {
    return action.payload;
  }
}, initialState);